import useSWR from 'swr'

import fetcher from 'utils/fetcher'

const useUserChangeHistory = (userId) => {
  const { data, isValidating, mutate } = useSWR(
    userId ? `/users/${userId}/changes` : null,
    fetcher,
    {
      revalidateOnFocus: false,
    }
  )

  return {
    changes: data?._embedded?.changes ?? [],
    loading: (!data?._embedded?.changes && !data?.error) || isValidating,
    validating: isValidating,
    error: data?.error,
    mutate,
  }
}

export default useUserChangeHistory
